import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import { StaticQuery, graphql } from "gatsby";
// import { HelmetDatoCms } from "gatsby-source-datocms";

import "../styles/index.sass";

const TemplateWrapper = ({ children }) => {
  const [showMenu, setShowMenu] = useState(false);

  return (
    <StaticQuery
      query={graphql`
        query LayoutQuery {
          datoCmsSite {
            globalSeo {
              siteName
            }
            faviconMetaTags {
              ...GatsbyDatoCmsFaviconMetaTags
            }
          }
          datoCmsHome {
            seoMetaTags {
              ...GatsbyDatoCmsSeoMetaTags
            }
            copyright
          }
          allDatoCmsSocialProfile(sort: { fields: [position], order: ASC }) {
            edges {
              node {
                profileType
                url
              }
            }
          }
        }
      `}
      render={data => (
        <div className={`container ${showMenu ? "is-open" : ""}`}>
          {/* <HelmetDatoCms
            favicon={data.datoCmsSite.faviconMetaTags}
            seo={data.datoCmsHome.seoMetaTags}
          /> */}
          <div className="container__sidebar">
            <div className="sidebar">
              <h6 className="sidebar__title">
                <Link to="/">{data.datoCmsSite.globalSeo.siteName}</Link>
              </h6>
              <div className="sidebar__intro">
                <p>photographer</p>
                <p>retoucher</p>
                <p>graphic designer</p>
              </div>
              <ul className="sidebar__menu">
                <li>
                  <Link to="/">Look book for brands</Link>
                </li>
                <li>
                  <Link to="/portrait">Portrait</Link>
                </li>
                <li>
                  <Link to="/commercial_catalogs">Commercial catalogs</Link>
                </li>
                <li>
                  <Link to="/subject_photo">Subject photo</Link>
                </li>
                <li>
                  <Link to="/about">About Me</Link>
                </li>
              </ul>
              <p className="sidebar__social">
                {data.allDatoCmsSocialProfile.edges.map(({ node: profile }) => (
                  <a
                    key={profile.profileType}
                    href={profile.url}
                    target="blank"
                    className={`social social--${profile.profileType.toLowerCase()}`}
                  >
                    {" "}
                  </a>
                ))}
              </p>
              <div className="sidebar__copyright">
                {data.datoCmsHome.copyright}
              </div>
            </div>
          </div>
          <div className="container__body">
          <div className="container__mobile-header">
                <div className="mobile-header__menu" >
                  <div style={{marginLeft: `20px`}}>

                  <button
                        className="drawler_menu"
                        aria-label="menu"
                        onClick={e => {
                          e.preventDefault();
                          setShowMenu(!showMenu);
                        }}
                      >

                  </button>
                  </div>
                
                   <div className="mobile-header__logo">
                  <Link to="/">{data.datoCmsSite.globalSeo.siteName}</Link>
                </div>
              </div>
          </div>
            {children}
          </div>
        </div>
      )}
    />
  );
};

TemplateWrapper.propTypes = {
  children: PropTypes.array
};

export default TemplateWrapper;